module.exports = __webpack_public_path__ + "1ea77b16321ae549f63dcea7cd028368.svg";